export default __webpack_public_path__ + "static/media/brigosha_logo.9983fe8d.svg";